import { Grid } from '@mui/material';
import InsightCard from './InsightCard';

export function InsightsGrid() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <InsightCard
          icon="🧑‍🤝‍🧑"
          title="Audience"
          insight="Votre public est majoritairement âgé de 18–25 ans et achète surtout le week-end."
          action="Créer une campagne ciblée"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <InsightCard
          icon="📅"
          title="Événements"
          insight="Les événements organisés le vendredi soir se remplissent 35% plus vite."
          action="Planifier un événement"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <InsightCard
          icon="💰"
          title="Prix"
          insight="Les billets à 5 000 FCFA ont le meilleur taux de conversion."
          action="Ajuster les prix"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <InsightCard
          icon="📣"
          title="Marketing"
          insight="Les campagnes avec influenceurs génèrent 2× plus de ventes que Facebook Ads."
          action="Lancer une campagne"
        />
      </Grid>
    </Grid>
  );
}
